import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import footerLogo from '../../assets/images/logo-without-shadow.svg'
import menuIcon from '../../assets/images/menu-icon.png'
import menuIconPlaceholder from '../../assets/images/menu-icon-placeholder.png'
import { useKeyboardControls } from '../../contexts/KeyboardControlsContext'
import { HighlightEffect } from '../../enums/KeyboardControls'
import { ControlHighlight, KeyboardControl } from '../molecules/KeyboardControls'
import ProgressiveImage from '../molecules/ProgressiveImage/ProgressiveImage'

const Footer = (): ReactElement => {
  const navigate = useNavigate()
  const keyboardControls = useKeyboardControls()

  const idButton = 'footer-button-account-details'

  return (
    <div className='flex justify-between w-full'>
      <div className='flex items-center'>
        <img src={footerLogo} className='w-[156px] cursor-pointer' alt='logo' />
        <span className='font-bold text-[38px] leading-[51.91px] text-dopage-lightGreen ml-[18.37px]'>College Overdose Prevention</span>
      </div>
      <ControlHighlight
        active={keyboardControls.isEnabled && keyboardControls.isElementFocused(idButton)}
        highlightEffect={HighlightEffect.ButtonHexOutline}
        data-testid={`highlight-${idButton}`}
      >
        <KeyboardControl>
          <button
            id={idButton}
            data-testid={idButton}
            className='px-[17px] py-[14px] flex cursor-pointer items-center text-[18px] rounded text-dopage-lightGreen font-bold hover:bg-[rgba(52,232,158,0.2)]'
            onClick={() => navigate('setting')}
          >
            <ProgressiveImage
              alt='Account Details Icon'
              placeholderSrc={menuIconPlaceholder}
              src={menuIcon}
              className='w-[52px]'
            />
          </button>
        </KeyboardControl>
      </ControlHighlight>
    </div>
  )
}

export default Footer
